<template>
  <div class="athletes_photos" style="padding-top:30px;">
    <template v-if="details.athleteList && details.athleteList.length > 0">
      <template v-for="item in getShowNum">
        <div class="rows" :key="item" :style="{pageBreakAfter:item % 8 === 0?'always':''}" :class="[item !== 1 && item % 8 === 1?'margin_top':'']">
          <div class="top" style="width:100%;display:flex">
            <div
              class="right_border custom_width"
              :style="{borderRight:'1px solid #999'}"
              style="width:118px;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 9,item * 9)"
              :key="index + '_' + item"
              :class="[index === 0?'left_border':'',item % 8 === 1 || item === 1?'top_border':'',(index + 1) % 9 === 0?'export_pdf_right':'']"
            >
              <div style="display:flex;justify-content:center;align-items:center;">
                <section style="padding:10px 10px 0;">
                  <img  :src="temp.headImage" style="width:90px;height:100px;" alt />
                </section>
              </div>
            </div>
          </div>
          <div class="bottom" style="width:100%;display:flex">
            <div
              class="right_border bottom_border custom_width"
              :style="{borderRight:'1px solid #999',borderBottom:'1px solid #999'}"
              style="width:118px;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-top:none;border-left:none;padding:10px;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 9,item * 9)"
              :key="index + '-' + item"
              :class="[index === 0?'left_border':'',(index + 1) % 9 === 0?'export_pdf_right':'',item === getShowNum?'export_pdf_bottom':'']"
            >
              <p class="athlete_info fonts_color" style="margin:0 0 10px;font-size:18px;color:#444;display:flex;padding:0;">
                <span :style="{marginRight:temp.signNumber?'16px':''}">{{temp.signNumber}}</span>
                <span style="max-width:110px;">{{temp.athleteName}}</span>
              </p>
              <p style="width:110px;box-sizing:border-box;margin:0;padding:0;;white-space: normal;word-break: break-all;word-wrap: break-word;text-align:center">{{temp.registerNumber}}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div
        style="height:200px;display:flex;align-items:center;justify-content:center;font-size:24px"
      >暂无数据</div>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: {
    details: {
      type: Object
    },
    matchName: {
      type: String
    }
  },
  data() {
    return {
      isRenders:false,
      userInfo: JSON.parse(getSession("userInfo")) || ""
    };
  },
  computed: {
    getShowNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 9) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 9
      ) {
        let length = this.details.athleteList.length;
        if (length / 9 > parseInt(length / 9)) {
          num = parseInt(length / 9) + 1;
        } else {
          num = length / 9;
        }
      }
      return num;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isRenders = true;
    });
  }
};
</script>
<style lang="less" scoped>
.athletes_photo {
  border: 1px solid #999;
  width: 1050px;
  margin: 0 auto;
}
.top_border {
    border-top:1px solid #999;
}
.left_border {
  border-left: 1px solid #999;
}
.bottom>div:first-of-type {
  border-left: 1px solid #999!important;
}
</style>